import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home/Home.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/towns',
    name: 'Towns',
    component: () => import( /* webpackChunkName: "about" */ '../views/town/TownList.vue')
  },
  {
    path: '/towns/:townId',
    name: 'TownDetail',
    component: () => import( /* webpackChunkName: "about" */ '../views/town/TownDetail.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import(/* webpackChunkName: "about" */ '../views/about/About.vue')
  }
]

const router = new VueRouter({
  routes,
  mode: 'history'
})

export default router
